import script from "./EventsBannerFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsBannerFilter.vue?vue&type=script&setup=true&lang=js"

import "./EventsBannerFilter.vue?vue&type=style&index=0&id=23e2ad1c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e2ad1c"]])

export default __exports__